export default __webpack_public_path__ + "static/listmaster-e6884106d83671de06586284c937dca3.png";